import angular from 'angular';
import _ from 'lodash';
import gridHeight from '../core/shared-service/grid-utils';
import moment from 'moment';

class listCompaniesCommunityCtrl {
    /*  @ngInject */

    constructor($state, logger, CommunitySvc, AuthSvc, $scope, $translate, uiGridExporterService, $stateParams) {
        this.$state = $state;
        this.logger = logger;
        this.AuthSvc = AuthSvc;
        this.CommunitySvc = CommunitySvc;
        this.$scope = $scope;
        this.$translate = $translate;
        this.uiGridExporterService = uiGridExporterService;
        this.$stateParams = $stateParams;
    }

    $onInit() {
        const eid = this.$stateParams.eid;
        let paginationOptions = {
            pageNumber: 0,
            pageSize: 20,
            sort: null,
        };

        this.containerPromise = this.CommunitySvc.getAllCompaniesOfCommunity(
            eid,
            paginationOptions.pageNumber,
            paginationOptions.pageSize
        );
        this.containerPromise.then(this.handleContainerPromise.bind(this));

        this.gridOptions = {
            columnDefs: [
                {
                    name: 'companyId',
                    displayName: 'ID Société',
                },
                {
                    name: 'companyName',
                    displayName: 'Raison social société',
                },
                {
                    name: 'fiscalId',
                    displayName: 'ID Fiscal',
                },
                {
                    name: 'legalId',
                    displayName: 'ID Légal',
                },
                {
                    name: 'principalEid',
                    displayName: 'ID DO',
                },
                {
                    name: 'membershipType',
                    displayName: "Type d'adhésion",
                },
                {
                    name: 'creationDate',
                    displayName: "Date d'adhésion",
                },
                {
                    name: 'eovDate',
                    displayName: "Date fin d'adhésion",
                },
            ],
            paginationPageSizes: [20, 50, 100],
            paginationPageSize: paginationOptions.pageSize,
            useExternalPagination: true,
            exporterCsvColumnSeparator: ';',
            exporterOlderExcelCompatibility: true,
            exporterHeaderFilter: this.$translate.instant,
            gridMenuTitleFilter: this.$translate,
            onRegisterApi: gridApi => {
                this.gridApi = gridApi;
                gridApi.pagination.on.paginationChanged(this.$scope, (newPage, pageSize) => {
                    paginationOptions.pageNumber = newPage;
                    paginationOptions.pageSize = pageSize;
                    this.containerPromise = this.CommunitySvc.getAllCompaniesOfCommunity(eid, newPage, pageSize);
                    this.containerPromise.then(this.handleContainerPromise.bind(this));
                });
            },
            enableSorting: true,
            enableGridMenu: false,
            enableColumnMenus: false,
        };
    }

    exportCsv() {
        const eid = this.$stateParams.eid;
        this.gridOptions.exporterCsvFilename =
            'sociétéMembres-' + eid + '-' + moment().format('DDMMYYYY_HHmm') + '.csv';

        this.CommunitySvc.getAllCompaniesOfCommunity(eid, 0, this.gridOptions.totalItems).then(data => {
            let gridApi2 = _.cloneDeep(this.gridApi);
            gridApi2.grid.modifyRows(data.data.content);
            this.uiGridExporterService.csvExport(this.gridApi.grid.api.grid, 'all', 'all');
        });
    }

    getGridHeight(gridApi) {
        return gridHeight(gridApi);
    }
    goBack() {
        this.$state.go('community.list.main');
    }

    handleContainerPromise(data) {
        if (data) {
            this.gridOptions.data = data.data.content;
            this.gridOptions.totalItems = data.data.totalElements;
            this.gridOptions.data.forEach(item => {
                item.membershipType = this.$translate.instant('community.membershipType.' + angular.lowercase(item.membershipType));
            });
        } else {
            this.logger.error('error.search');
        }
    }
}

angular.module('app.community').component('listCompaniesCommunity', {
    templateUrl: require('./list-companies-community.html'),
    controller: listCompaniesCommunityCtrl,
    bindings: {
        initMenuConsult: '<',
        community: '<',
    },
});
